import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "../../layout/main-layout/main-layout.component";
import { WpaIntroductionComponent } from "./introduction/wpa-introduction.component";

export default [
	{
		path: "wpa/:surveyId/introduction",
		component: WpaIntroductionComponent,
	},
	{
		path: "wpa",
		component: MainLayoutComponent,
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./wpa.component").then((c) => c.WpaComponent),
			},
			{
				path: "results",
				loadComponent: () =>
					import("./wpa-results/wpa-results.component").then(
						(c) => c.WpaResultsComponent,
					),
			},
			{
				path: "services",
				loadComponent: () =>
					import("./wpa-services/wpa-services.component").then(
						(c) => c.WpaServicesComponent,
					),
			},
			{
				path: "details/:surveyId/:groupId",
				loadComponent: () =>
					import("./wpa-details/wpa-details.component").then(
						(c) => c.WpaDetailsComponent,
					),
			},
		],
	},
] satisfies Routes;
